import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useNavigate } from "react-router";

// components
import { RightArrow } from "components/common";

//utils
import { moneyFormatter } from "utils";

const ReceivableCard = ({ amount, isAll, isError, onRefresh, ...props }) => {
  const navigate = useNavigate();

  return (
    <MainWrapper
      onClick={() => {
        if (isError) return;
        navigate(isAll ? "/sales/branch/receivable" : "/sales/receivable");
      }}
    >
      <Text>누적 미수금</Text>

      {isError ? (
        <AmountWrapper>
          <ErrorText>불러오지 못했어요</ErrorText>
          <RefreshButton type="button" onClick={onRefresh}>
            새로고침
          </RefreshButton>
        </AmountWrapper>
      ) : (
        <AmountWrapper>
          <Text>{moneyFormatter(amount)}</Text>
          <RightArrow size="S" />
        </AmountWrapper>
      )}
    </MainWrapper>
  );
};

const MainWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 12px;
  padding: 24px;
  border-radius: 12px;
  height: 72px;
  background-color: ${(props) => props.theme.colors.cardBackground};
`;

const Text = styled.p`
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.primaryTextColor};
  font-feature-settings: "tnum" on, "lnum" on;
`;

const AmountWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  p {
    margin-right: 8px;
  }
`;

const ErrorText = styled(Text)`
  font-weight: normal;
  font-size: 16px;
  opacity: 0.66;
`;

const RefreshButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.primaryTextColor};
  text-decoration: underline;
`;

ReceivableCard.propTypes = {
  amount: PropTypes.number,
  isAll: PropTypes.bool,
  isError: PropTypes.bool,
  onRefresh: PropTypes.func,
};

export default ReceivableCard;
